<template>
  <div>
    <ValidationObserver #default="{invalid}">
      <BRow class="my-3">
        <BCol md="6">
          <h4 class="text-black">
            Pengaturan Notifikasi
          </h4>
          <BFormGroup>
            <template #label>
              <div class="text-black flex items-center mt-2">
                <span class="text-md font-medium">Target Notifikasi</span>
                <span class="text-primary">*</span>
              </div>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Target Notifikasi"
              rules="required"
            >
              <BRow>
                <BCol>
                  <div
                    id="popover-button"
                    class="d-flex flex-wrap border-2 rounded p-[5px] justify-between align-items-center"
                  >
                    <span v-if="selectedTarget.length === 0">Pilih Target Notifikasi</span>
                    <div
                      v-for="(group, groupIndex) in selectedTarget"
                      :key="groupIndex"
                      class="d-flex flex-wrap gap-1"
                    >
                      <div
                        v-for="(product, productIndex) in group.products"
                        :key="productIndex"
                        class="d-flex align-items-center border rounded px-[8px] gap-2 bg-[#F95031] h-[30px] mr-1 mb-1"
                      >
                        <img
                          :src="product.logo"
                          width="20px"
                          class="mr-[5px]"
                        >
                        <span class="text-white text-[12px]">{{ product.name }}</span>
                        <b-icon
                          icon="x"
                          font-scale="1.2"
                          class="ml-[5px] text-white"
                          style="cursor: pointer"
                          @click.stop="removeProductByName(group.category, product.name)"
                        />
                      </div>
                    </div>
                    <img
                      src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg"
                      alt="arrow"
                      width="16px"
                    >
                  </div>

                  <b-popover
                    :show.sync="isPopoverOpen"
                    target="popover-button"
                    triggers="click"
                    placement="bottom"
                    custom-class="w-100"
                  >
                    <div
                      v-for="(category, index) in optionTarget"
                      :key="index"
                      class="mb-2"
                    >
                      <div
                        v-if="category.product_menu && category.product_menu.length"
                        v-b-toggle="`collapse-${category.label}`"
                        class="d-flex justify-between align-items-center"
                      >
                        <b-form-checkbox
                          v-model="category.checked"
                          @change="toggleCategory(category)"
                        >
                          <div class="d-flex align-items-center">
                            <img
                              :src="getCategoryLogo(category)"
                              height="24"
                              class="mr-2"
                              width="24px"
                            >
                            <span>{{ category.product_categories }}</span>
                          </div>
                        </b-form-checkbox>
                        <div class="ml-2">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="when-closed"
                          />
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="when-opened"
                          />
                        </div>
                      </div>

                      <b-form-checkbox
                        v-else
                        v-model="category.checked"
                        @change="toggleCategory(category)"
                      >
                        <div class="d-flex align-items-center">
                          <img
                            :src="getCategoryLogo(category)"
                            height="24"
                            class="mr-2"
                            width="24px"
                          >
                          <span>{{ category.product_categories }}</span>
                        </div>
                      </b-form-checkbox>

                      <BCollapse
                        v-if="category.product_menu && category.product_menu.length"
                        :id="`collapse-${category.label}`"
                      >
                        <div class="ml-4 mt-1">
                          <b-form-checkbox
                            v-for="(product, pIndex) in category.product_menu"
                            :key="pIndex"
                            v-model="product.checked"
                            @change="toggleProduct(category)"
                          >
                            <div class="d-flex align-items-center">
                              <img
                                :src="getProductLogo(product)"
                                height="20"
                                class="mr-2"
                                width="24px"
                              >
                              <span>{{ product.product_name }}</span>
                            </div>
                          </b-form-checkbox>
                        </div>
                      </BCollapse>
                    </div>
                  </b-popover>

                </BCol>
              </BRow>
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
          </BFormGroup>
          <ValidationProvider
            #default="{ errors }"
            name="Judul"
            rules="required|max:50"
          >
            <BFormGroup>
              <template #label>
                <div class="text-black flex items-center">
                  <span class="text-md font-medium">Judul</span>
                  <span class="text-primary">*</span>
                </div>
              </template>
              <BFormInput
                v-model="title"
                :state="errors.length > 0 ? false : null"
                placeholder="Masukan judul notifikasi kamu"
                class="mb-1"
              />
              <small class="text-primary">{{ errors[0] }}</small>
            </BFormGroup>
          </ValidationProvider>
          <ValidationProvider
            #default="{ errors }"
            name="Deskripsi"
            rules="required|max:240"
          >
            <BFormGroup>
              <template #label>
                <div class="text-black flex items-center">
                  <span class="text-md font-medium">Deskripsi</span>
                  <span class="text-primary">*</span>
                </div>
              </template>
              <BFormTextarea
                v-model="desc"
                :state="errors.length > 0 ? false : null"
                placeholder="Masukan deskripsi kamu"
                class="mb-1"
                rows="4"
              />
              <small class="text-primary">{{ errors[0] }}</small>
            </BFormGroup>
          </ValidationProvider>
          <BFormGroup>
            <template #label>
              <div class="text-black flex items-center">
                <span class="text-md font-medium">Pengaturan Waktu</span>
              </div>
            </template>
            <date-range-picker
              ref="picker"
              v-model="dateRange"
              :locale-data="locale"
              :ranges="ranges"
              :opens="'auto'"
              control-container-class="border-1"
              class="w-100"
              :time-picker="true"
              :time-picker-seconds="true"
              :min-date="minDate"
            >
              <template v-slot:input="picker">
                <div class="border-2 border-[#E2E2E2] rounded-[8px] px-2 h-[37px] flex items-center justify-between">
                  <div class="flex gap-5 items-center justify-between">
                    <span v-if="picker.startDate">
                      {{ DATE_NUMBER_DASH(picker.startDate) + ' ' + TIME(picker.startDate) }}
                    </span>
                    <span v-else>Start Date</span>
                    <img
                      src="https://storage.googleapis.com/komerce/icon/arrow-right-half-secondary.svg"
                      alt="arrow"
                      width="20px"
                    >
                    <span v-if="picker.endDate">
                      {{ DATE_NUMBER_DASH(picker.endDate) + ' ' + TIME(picker.endDate) }}
                    </span>
                    <span v-else>End Date</span>
                  </div>
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/calendar.svg"
                    alt="calendar"
                    class="flex justify-end"
                    width="20px"
                  >
                </div>
              </template>
            </date-range-picker>
          </BFormGroup>
          <BFormGroup>
            <template #label>
              <div class="text-black flex items-center mt-2">
                <span class="text-md font-medium">Link URL</span>
              </div>
            </template>
            <BFormInput
              v-model="link"
              placeholder="Masukan link URL"
              class="mb-1"
            />
          </BFormGroup>
          <ValidationProvider
            #default="{ errors }"
            name="Warna"
            rules="required"
          >
            <BFormGroup>
              <template #label>
                <div class="text-black flex items-center">
                  <span class="text-md font-medium">Warna</span>
                  <span class="text-primary">*</span>
                </div>
              </template>
              <div
                class="p-1 border-[1px] border-[#E2E2E2] rounded-[49px]"
                style="max-width: 235px"
              >
                <button
                  v-for="items in colorOptions"
                  :id="items.id"
                  :key="items.id"
                  :state="items.active ? true : null"
                  class="color-options rounded-full ml-1"
                  :class="items.active ? 'active' : ''"
                  @click="setColors(items)"
                />
              </div>
              <small class="text-primary">{{ errors[0] }}</small>
            </BFormGroup>
          </ValidationProvider>
        </BCol>
        <BCol md="6">
          <span class="text-black text-[16px] font-medium mb-2">Preview</span>
          <div class="bg-[#F8F8F8] d-flex py-2 mt-2">
            <img
              v-if="colorOptions[0].active "
              src="https://storage.googleapis.com/komerce/assets/banner/preview-notif-success.svg"
              alt="Komerce"
              class="mx-auto"
            >
            <img
              v-if="colorOptions[1].active "
              src="https://storage.googleapis.com/komerce/assets/banner/preview-notif-warning.svg"
              alt="Komerce"
              class="mx-auto"
            >
            <img
              v-if="colorOptions[2].active "
              src="https://storage.googleapis.com/komerce/assets/banner/preview-notif-danger.svg"
              alt="Komerce"
              class="mx-auto"
            >
            <img
              v-if="colorOptions[3].active "
              src="https://storage.googleapis.com/komerce/assets/banner/preview-notif-info.svg"
              alt="Komerce"
              class="mx-auto"
            >
          </div>
        </BCol>
      </BRow>
      <div class="d-flex justify-content-end mb-1">
        <BButton
          :variant="invalid ? 'outline-secondary' : 'outline-primary'"
          class="rounded-lg"
          :disabled="invalid || disableBtn || !color || selectedTarget.length === 0"
          @click="submit('save')"
        >
          Draft
        </BButton>
        <BButton
          :variant="invalid ? 'secondary' : 'primary'"
          class="rounded-lg ml-1"
          :disabled="invalid || disableBtn || !color || selectedTarget.length === 0"
          @click="submit('submit')"
        >
          Publish
        </BButton>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import {
  LABELDAY, LABELMONTH, DATE_NUMBER_DASH, TIME,
} from '@/libs/filterDate'
import moment from 'moment'
import {
  today,
  firstDateOfMonth,
  lastDateOfMonth,
} from '@/store/helpers'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import ToastificationContentVue from '@/@core/components/toastification/ToastificationContent.vue'
import { newAxiosIns } from '@/libs/axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    DateRangePicker,
  },
  data() {
    return {
      DATE_NUMBER_DASH,
      TIME,
      picker: {
        startDate: firstDateOfMonth,
        endDate: lastDateOfMonth,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'Custom Range': {
          label: 'Custom Range',
          startDate: today,
          endDate: today,
        },
      },
      today,
      firstDateOfMonth,
      lastDateOfMonth,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      colorOptions: [
        { id: 'colors-1', value: '#B6FBC9', active: false },
        { id: 'colors-2', value: '#FFDF82', active: false },
        { id: 'colors-3', value: '#F86363', active: false },
        { id: 'colors-4', value: '#BEE6FC', active: false },
      ],
      title: null,
      desc: null,
      link: null,
      color: null,
      required,
      disableBtn: false,
      selectedProd: [],
      checkTarget: false,
      target: [],
      optionTarget: [],
      bannerFile: null,
      previewUrl: null,
      indeterminate: false,
      selectedTarget: [],
      isPopoverOpen: false,
      id: this.$route.params.id,
      originalStartDate: today,
      originalEndDate: today,
      dateChanged: false,
      minDate: moment().format('YYYY-MM-DD HH:mm:ss'),
    }
  },
  computed: {
    selectedProducts() {
      return this.optionTarget
        .flatMap(category => category.product_menu || [])
        .filter(product => product.checked)
    },
  },
  watch: {
    dateRange: {
      handler(newVal, oldVal) {
        if (newVal && newVal.startDate) {
          if (!this.dateChanged) {
            this.dateChanged = true
          }
          const now = moment()
          let selectedStart = moment(newVal.startDate)
          let selectedEnd = newVal.endDate ? moment(newVal.endDate) : null

          const oldStart = oldVal?.startDate ? moment(oldVal.startDate) : null
          const isStartDateChanged = !oldStart || !selectedStart.isSame(oldStart)

          if (isStartDateChanged && selectedStart.isBefore(now)) {
            selectedStart = now
          }

          if (selectedEnd && (selectedEnd.isSameOrBefore(selectedStart))) {
            selectedEnd = selectedStart.clone().add(5, 'minutes')
          }

          const updated = !selectedStart.isSame(newVal.startDate)
          || (selectedEnd && !selectedEnd.isSame(newVal.endDate))

          if (updated) {
            this.dateRange = {
              startDate: selectedStart,
              endDate: selectedEnd,
            }
          }
        } else {
          this.minDate = moment()
        }
      },
      immediate: false,
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    this.getListProducts()
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const popoverButton = this.$el.querySelector('#popover-button')
      const popoverContent = document.querySelector('.popover')

      if (
        this.isPopoverOpen
      && !popoverButton.contains(event.target)
      && !(popoverContent && popoverContent.contains(event.target))
      ) {
        this.isPopoverOpen = false
      }
    },
    toggleCategory(category) {
      if (category.product_menu && category.product_menu.length) {
        category.product_menu.forEach(product => {
          // eslint-disable-next-line no-param-reassign
          product.checked = category.checked
        })
      }
      this.buildSelectedTarget()
    },

    toggleProduct(category) {
      if (category.product_menu) {
        // eslint-disable-next-line no-param-reassign
        category.checked = category.product_menu.every(p => p.checked)
      }
      this.buildSelectedTarget()
    },

    removeProduct(productToRemove) {
      this.optionTarget.forEach(category => {
        if (category.product_menu && category.product_menu.length) {
          category.product_menu.forEach(product => {
            if (product.label === productToRemove.label) {
              // eslint-disable-next-line no-param-reassign
              product.checked = false
            }
          })
          // eslint-disable-next-line no-param-reassign
          category.checked = category.product_menu.some(p => p.checked)
        } else if (category.label === productToRemove.label) {
          // eslint-disable-next-line no-param-reassign
          category.checked = false
        }
      })
      this.buildSelectedTarget()
    },

    removeProductByName(categoryName, productName) {
      const category = this.optionTarget.find(cat => cat.product_categories === categoryName)
      if (!category) return

      if (category.product_menu && category.product_menu.length) {
        const product = category.product_menu.find(p => p.product_name === productName)
        if (product) product.checked = false
        category.checked = category.product_menu.every(p => p.checked)
      } else if (category.product_categories === productName) {
        category.checked = false
      }
      this.buildSelectedTarget()
    },

    updateSelectedTarget() {
      this.buildSelectedTarget()
    },

    buildSelectedTarget() {
      this.selectedTarget = this.optionTarget
        .map(cat => {
          const selectedProducts = (cat.product_menu || [])
            .filter(p => p.checked)
            .map(p => ({
              name: p.product_name,
              logo: this.getProductLogo(p, true),
            }))

          const isStandaloneCategory = (!cat.product_menu || !cat.product_menu.length) && cat.checked
          if (selectedProducts.length || isStandaloneCategory) {
            const whiteLogo = (cat.category_logo || []).find(l => l.type === 'white')
            return {
              category: cat.product_categories,
              products: selectedProducts.length ? selectedProducts : [{
                name: cat.product_categories,
                logo: whiteLogo ? whiteLogo.url : '',
              }],
            }
          }
          return null
        })
        .filter(Boolean)
    },
    getProductLogo(product, isWhite = false) {
      const logo = (product.product_logo || []).find(l => l.type === (isWhite ? 'white' : 'default'))
      return logo ? logo.url : ''
    },
    getCategoryLogo(category) {
      const logo = category.category_logo.find(l => l.type === 'default')
        || category.category_logo[0]
      return logo.url
    },
    setColors(items) {
      // eslint-disable-next-line no-plusplus
      for (let x = 0; x < this.colorOptions.length; x++) {
        if (this.colorOptions[x].id === items.id) {
          this.colorOptions[x].active = true
        } else {
          this.colorOptions[x].active = false
        }
      }
      this.color = items.value
    },
    async submit(action) {
      this.disableBtn = true
      const url = 'sender/api/v2/campaign/notification-bar'
      const urlUpdate = `/sender/api/v2/campaign/notification-bar/${this.id}`
      const formData = this.buildFormData(action)

      const sendRequest = async () => {
        const request = this.id
          ? newAxiosIns.put(urlUpdate, formData)
          : newAxiosIns.post(url, formData)

        await request
          .then(() => {
            this.$router.push('/campaign/notification')
            this.showToast('Success', 'CheckIcon', 'Notifikasi berhasil dibuat', 'success')
          })
          .catch(err => {
            this.showToast('Failure', 'AlertCircleIcon', err.response.data.message, 'danger')
            this.disableBtn = false
          })
      }

      if (action === 'submit') {
        this.showConfirmDialog(() => sendRequest())
      } else {
        sendRequest()
      }
    },
    buildFormData(action) {
      const formData = new FormData()
      const selectedTargetStructure = this.optionTarget
        .flatMap(cat => {
          const allProductsChecked = cat.product_menu?.length && cat.product_menu.every(p => p.checked)
          const selectedProducts = (cat.product_menu || []).filter(p => p.checked).map(p => p.label)
          const hasProducts = selectedProducts.length > 0
          const onlyCategoryChecked = (!cat.product_menu?.length && cat.checked)

          if (cat.label === 'partner') {
            if (allProductsChecked) {
              return [cat.label, ...selectedProducts]
            }
            if (hasProducts) {
              return selectedProducts
            }
            if (onlyCategoryChecked) {
              return [cat.label]
            }
          } else {
            if (hasProducts) {
              return [cat.label === 'collaborator' ? '' : cat.label, ...selectedProducts]
            }
            if (onlyCategoryChecked) {
              return [cat.label]
            }
          }

          return []
        })
        .filter(Boolean)
        .join(',')

      formData.append('action', action)
      formData.append('type', 'message')
      formData.append('title', this.title)
      formData.append('description', this.desc)
      formData.append('color', this.color)
      formData.append('url_link', this.link ? this.link : '')
      formData.append('status', action === 'submit' ? 1 : 2)
      formData.append('target', selectedTargetStructure)
      formData.append('is_recurring', 1)

      if (this.dateChanged) {
        formData.append('start_date', moment(this.dateRange.startDate).format('YYYY-MM-DD HH:mm:ss'))
        formData.append('end_date', moment(this.dateRange.endDate).format('YYYY-MM-DD HH:mm:ss'))
      }

      return formData
    },
    showConfirmDialog(onConfirm) {
      this.$swal({
        title: '<span class="font-medium text-[16px]">Kamu yakin ingin mempublish notifikasi ini?</span>',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.svg'),
        confirmButtonText: 'Ya, Publish',
        confirmButtonClass: 'btn btn-primary rounded-lg',
        showCancelButton: true,
        cancelButtonText: 'Batal',
        cancelButtonClass: 'btn btn-outline-primary bg-white text-primary rounded-lg',
      }).then(result => {
        if (result.isConfirmed) {
          onConfirm()
        } else {
          this.disableBtn = false
        }
      })
    },

    showToast(title, icon, text, variant) {
      this.$toast({
        component: ToastificationContentVue,
        props: {
          title, icon, text, variant,
        },
      }, { timeout: 1000 })
    },
    async getListProducts() {
      const url = 'sender/api/v2/campaign/get-info'
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data

          this.optionTarget = data.option_targets.map(cat => ({
            ...cat,
            checked: false,
            product_menu: cat.product_menu
              ? cat.product_menu.map(product => ({
                ...product,
                checked: false,
              }))
              : [],
          }))
        })
      if (this.id) this.getDataDraft()
    },
    async getDataDraft() {
      const url = `/sender/api/v2/campaign/notification-bar/${this.id}`
      await newAxiosIns.get(url)
        .then(res => {
          const { data } = res.data
          this.title = data.title
          this.desc = data.description
          this.link = data.url_link
          this.color = data.color

          if (data.start_date) {
            this.dateRange.startDate = moment(data.start_date).format('YYYY-MM-DD HH:mm:ss')
          }
          if (data.end_date) {
            this.dateRange.endDate = moment(data.end_date).format('YYYY-MM-DD HH:mm:ss')
          }

          this.colorOptions.forEach(color => {
            // eslint-disable-next-line no-param-reassign
            color.active = color.value === data.color
          })

          if (data.target && data.target.product && this.optionTarget.length) {
            data.target.product.forEach(draftProduct => {
              this.optionTarget.forEach(category => {
                if (category.product_menu && category.product_menu.length) {
                  const matchedProduct = category.product_menu.find(p => p.label === draftProduct.product_label)
                  if (matchedProduct) {
                    matchedProduct.checked = true
                  }
                } else {
                  // eslint-disable-next-line no-lonely-if
                  if (category.label === draftProduct.product_label) {
                    // eslint-disable-next-line no-param-reassign
                    category.checked = true
                  }
                }
              })
            })

            this.optionTarget.forEach(category => {
              if (category.product_menu && category.product_menu.length) {
                // eslint-disable-next-line no-param-reassign
                category.checked = category.product_menu.every(p => p.checked)
              }
            })

            this.updateSelectedTarget()
          }
        })
    },

  },
}
</script>
<style lang="scss" src="../notification.scss" />
<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/vue/libs/vue-flatpicker.scss';
@import '~quill/dist/quill.snow.css';

.vs__dropdown-menu {
  max-height: 230px;
}
.vs__deselect {
  display: none !important;
}
.dropdownitem {
  .btn {
    display: flex;
    justify-content: space-between;
  }
}
.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }

.bg-red {
  background-color: #f5532e;
  color: white;
  width: fit-content;
}
</style>
